import { LegacyEvaluation } from '@/types/legacyEvaluation';

export enum ActionTypes {
  FETCH_EVALUATIONS_START = 'evaluations/FETCH_EVALUATIONS_START',
  FETCH_EVALUATIONS_SUCCESS = 'evaluations/FETCH_EVALUATIONS_SUCCESS',
  FETCH_EVALUATIONS_FAIL = 'evaluations/FETCH_EVALUATIONS_FAIL',
  CLEAR_EVALUATIONS = 'evaluations/CLEAR_EVALUATIONS',
}

export interface State {
  isLoading: boolean;
  error: string;
  data?: LegacyEvaluation[];
}
export interface FetchEvaluationsStartAction {
  type: ActionTypes.FETCH_EVALUATIONS_START;
}
export interface FetchEvaluationsSuccessAction {
  type: ActionTypes.FETCH_EVALUATIONS_SUCCESS;
  payload: LegacyEvaluation[];
}
export interface FetchEvaluationsFailAction {
  type: ActionTypes.FETCH_EVALUATIONS_FAIL;
  payload: string;
}

export interface ClearEvaluations {
  type: ActionTypes.CLEAR_EVALUATIONS;
}

export type ActionType =
  | FetchEvaluationsStartAction
  | FetchEvaluationsSuccessAction
  | FetchEvaluationsFailAction
  | ClearEvaluations;
